import { render, staticRenderFns } from "./LocationLimitEditor.vue?vue&type=template&id=4bfd0089"
import script from "./LocationLimitEditor.vue?vue&type=script&lang=js"
export * from "./LocationLimitEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports